import { Component, OnInit, ViewChild } from '@angular/core';
import 'anychart';
import * as moment from 'moment';
import { ApiserviceService } from 'src/app/services/apiservice.service';

@Component({
  selector: 'app-dasboard',
  templateUrl: './dasboard.page.html',
  styleUrls: ['./dasboard.page.scss'],
})
export class DasboardPage implements OnInit {

  @ViewChild('popover') popover;
  @ViewChild('popoverplanta') popoverplanta;

  chartbarra = anychart.bar();  
  series

  chartbarra2 = anychart.bar();  
  series2

 
  


  listafecha=[
    {'id':0,'descripcion':'Mes Actual','estado':true},
    {'id':1,'descripcion':'1 Mes','estado':false},
    {'id':2,'descripcion':'6 Mes','estado':false},
    {'id':3,'descripcion':'1 Año','estado':false},
    {'id':4,'descripcion':'Año Actual','estado':false},
    {'id':5,'descripcion':'Rango Fechas','estado':false}    
  ];

  plantas=[    
    {'id':"1","descripcion":"Planta Espino","estado":false},
    {'id':"2","descripcion":"Planta Espriella","estado":false},
    {'id':"3","descripcion":"Planta Mocoa","estado":false},
    {'id':"4","descripcion":"Planta Pasto","estado":false},
    {'id':"5","descripcion":"Planta Pitalito","estado":false},
    {'id':"6","descripcion":"Todas","estado":true}]


   idplanta=""

    desplanta="Todas";


  isOpen = false;
  isOpenplanta = false;
  fedesde=moment().format("yyyy-MM-DD");
  fehasta=moment().format("yyyy-MM-DD");
  hoy=moment().format("yyyy-MM-DD HH:mm:ss");

  plataforma



  /*

  	0=>pendiente,
    1=>liberado 
    2=>realizado
    3=>Fuera de linea,
    4=> sin MST,
    5=>castigado // Nota: Para Castigar debe estar en estado {0,1}

  */

datahorizontal = [
    {x: "OTS Creadas", value: 0, fill: "#3dc2ff",id: "1"},
    {x: "OTS Pendientes", value: 0, fill: "#ffc409",id: "0"},
    {x: "OTS Realizadas", value: 0, fill: "#2dd36f",id: "2"},
    {x: "OTS Canceladas", value: 0, fill: "#eb445a",id: "5"},
    //... Puedes seguir añadiendo meses y colores aquí
];

datahorizontal2 = [
    {x: "OTS Preventivas", value: 0, fill: "#3dc2ff",id: "1"},  
    {x: "OTS Condicion", value: 0, fill: "#2dd36f",id: "2"},
    {x: "OTS Predictivas", value: 0, fill: "#ffc409",id: "0"},
    {x: "OTS Correctivas", value: 0, fill: "#eb445a",id: "5"},
  //... Puedes seguir añadiendo meses y colores aquí
];


 datapie = [
  ["Creadas", 2],
  ["Pendientes",2],
  ["Realizadas",2],
  ["Canceladas", 2],

];


//mayor a menor....

 datapareto = [
  /*{ x: 'Planta \n Espino', value: 95 },
  { x: 'Planta \n Espriella', value: 60 },
  { x: 'Planta \n Mocoa', value: 45 },
  { x: 'Planta \n Pasto', value: 37 },
  { x: 'Planta \n Pitalito', value: 30 },*/
  //{ x: 'Clothing Faded', value: 27 },
  //{ x: 'Clothing Shrank', value: 18 }
];

datapareto2 = [  
  //{ x: 'Clothing Faded', value: 27 },
  //{ x: 'Clothing Shrank', value: 18 }
];

datapareto3 = [  
  //{ x: 'Clothing Faded', value: 27 },
  //{ x: 'Clothing Shrank', value: 18 }
];

datapareto4 = [  
  //{ x: 'Clothing Faded', value: 27 },
  //{ x: 'Clothing Shrank', value: 18 }f
];

datapareto5 = [  
  //{ x: 'Clothing Faded', value: 27 },
  //{ x: 'Clothing Shrank', value: 18 }
];

datapareto6 = [  
  //{ x: 'Clothing Faded', value: 27 },
  //{ x: 'Clothing Shrank', value: 18 }
];

datapareto7 = [  
  //{ x: 'Clothing Faded', value: 27 },
  //{ x: 'Clothing Shrank', value: 18 }
];

datapareto8 = [  
  //{ x: 'Clothing Faded', value: 27 },
  //{ x: 'Clothing Shrank', value: 18 }
];

chartpie = anychart.pie3d(this.datapie);
chartpareto = anychart.pareto(this.datapareto);
chartpareto2 = anychart.pareto(this.datapareto2);
chartpareto3 = anychart.pareto(this.datapareto3);
chartpareto4 = anychart.pareto(this.datapareto4);
chartpareto5 = anychart.pareto(this.datapareto5);
chartpareto6 = anychart.pareto(this.datapareto6);
chartpareto7 = anychart.pareto(this.datapareto7);
chartpareto8 = anychart.pareto(this.datapareto8);

sist1=false;
sist2=false;
sist3=false;
sist4=false;
sist5=false;
sist6=false;
sist7=false;
sist8=false;


auxadm=true;

@ViewChild('popoverayuda') popoverayuda;
@ViewChild('popoverusuario') popoverusuario;

isOpenayuda = false;
isOpenusuario = false;

////////////////////////////////////////////


@ViewChild('popovervent') popovervent;
isOpenvent = false;

menuayuda="recorrido";

  recorrido=
  
  {
  'pos':0,  
  'max':3,
  'pasos':[  
   {'titulo':'informacion',
    'informacion':'<strong> El Modulo Dashboard </strong> gestiona el listado de las empresas donde se realizan las compras de los Repuestos o Items ',
    'id':'',
    'class':''
  },
  
  { 'titulo':'Recorrido',
    'informacion':'Boton para Filtrar por fechas',
    'id':'pt1',
    'class':''},

    { 'titulo':'Recorrido',
    'informacion':'Boton para Filtrar por Plantas',
    'id':'pt2',
    'class':''},

    { 'titulo':'Recorrido',
    'informacion':'Informacion de Dashboard',
    'id':'',
    'class':''},

 
  ]
  };

  titulo="";
descripcion="";

estaatras=false;
estsiguiente=false;

movayuven={
  'pos':0,  
  'max':0,
  'pasos':[ ]
};


////////////////////////////////////////////

  constructor(public apiservice: ApiserviceService,) { }

  presentPopover(e: Event) {
    this.popover.event = e;
    this.isOpen = true;
  }

  presentPopoverplanta(e: Event) {
    this.popoverplanta.event = e;
    this.isOpenplanta = true;
  }

  ngOnInit() {

    
    this.series=  this.chartbarra.bar();   
    this.series2= this.chartbarra2.bar();      
    this.chartpie= anychart.pie3d(this.datapie);
    this.chartpareto=  anychart.pareto(this.datapareto);
    this.chartpareto2=  anychart.pareto(this.datapareto2);


  }

  
  ionViewWillEnter(){
   
    this.apiservice.startloading();
    this.plataforma=this.apiservice.plataforma()[0]['desktop'];       

    this.auxadm=true;

    this.infoplantas();
    ///////////////////////////////////////////////////////////////////

    this.grafbarras();
    this.grafpie3d();
    this.grafbarhorizontal();
    //this.pareto();
    //this.paretosit(this.chartpareto2,this.datapareto2,'pareto3','xxxxx');
    //this.paretosit(this.chartpareto3,this.datapareto3,'pareto4','yyyyy');
    //this.paretosit(this.chartpareto4,this.datapareto4,'pareto5','zzzzz');
    this.estrategia();
    this.camplanta(6);
    this.camfecha(0);

  setTimeout(() => {

    this.modificarista();
    
  },1000);
   

    ///////////////////////////////////////////////////////////////////
    
    

  }

  
  verayuda(id){

    this.movayuven=id;
    this.vermov();
    //presentPopoverayuda($event)"
      
    }
  
   reiniciar(){
  
    this.movayuven['pos']=0;
    this.vermov();
  
   }
  
   btnatras(){
    
    if(this.movayuven['pos']==0){
      this.estaatras=true;
      }else
      {
      this.estaatras=false;
      }
  
   }
  
   btnsiguiente(){
    
    if(this.movayuven['max']==this.movayuven['pos'])
    this.estsiguiente=true;
    else{
      this.estsiguiente=false;
    }
  
   }  
  
  vermov(){
  
    var data=this.movayuven['pasos'][ this.movayuven['pos']]
    this.titulo=data.titulo
    this.descripcion=data.informacion;
  
    this.btnatras();
    this.btnsiguiente();
    this.isOpenvent = false;

    // side="top" 

    //this.popovervent.side="top";  

    this.popovervent.cssClass="oscar"+data.class;
  
    this.popovervent.backdropDismiss=false;
  
    ///////////////////////////////////////////
    var element = document.getElementById(data.id);
    //////////////////////////////////////////
  
    this.popovervent.event ={
      target:element
    }
  
    this.isOpenayuda = false;
  
    setTimeout(() => {
      this.isOpenvent = true;
    }, 400);
   
  
  }
  
    siguiente(){
  
      if(this.movayuven['pos'] < this.movayuven['max']){
        this.movayuven['pos']=this.movayuven['pos']+1;
        this.vermov();
      }
  
    }
  
    atras(){
  
      if(this.movayuven['pos']>0){
        this.movayuven['pos']=this.movayuven['pos']-1;
        this.vermov();
      }
  
    }


  async infoplantas(){


this.sist1=false;
this.sist2=false;
this.sist3=false;
this.sist4=false;
this.sist5=false;
this.sist6=false;
this.sist7=false;
this.sist8=false;

       var bus={
      'idcod':'39'
      }
  
   var resmod=await this.apiservice.postbusapi2(bus);
   console.log(resmod);
   var res=resmod;


   console.log(this.idplanta)

   var sist=this.idplanta;

   if(this.idplanta=='6'){
    sist='4';
   }
 

   try {
    
   

   res=res.filter(x=>{ return x.id==sist});
   //filtro el sistema

   if(res.length>0){

  for(var i=0;i<res[0]['info'].length;i++){
   
   if(res[0]['info'][i]['id']==1)
   {this.sist1=true   
      this.paretosit(this.chartpareto,this.datapareto,'pareto',res[0]['info'][i]['descripcion']);
   }
   if(res[0]['info'][i]['id']==2)
   {this.sist2=true
    
   this.paretosit(this.chartpareto2,this.datapareto2,'pareto2',res[0]['info'][i]['descripcion']);
 
  }
   if(res[0]['info'][i]['id']==3)
   {this.sist3=true
   
   this.paretosit(this.chartpareto3,this.datapareto3,'pareto3',res[0]['info'][i]['descripcion']);
 
  }
   if(res[0]['info'][i]['id']==4)
   {this.sist4=true

   
   this.paretosit(this.chartpareto4,this.datapareto4,'pareto4',res[0]['info'][i]['descripcion']);
  
  }
   if(res[0]['info'][i]['id']==5)
   {this.sist5=true
  
   this.paretosit(this.chartpareto5,this.datapareto5,'pareto5',res[0]['info'][i]['descripcion']);
  
  }
   if(res[0]['info'][i]['id']==6)
   {this.sist6=true
  
   this.paretosit(this.chartpareto6,this.datapareto6,'pareto6',res[0]['info'][i]['descripcion']);
  
  }
   if(res[0]['info'][i]['id']==7)
   {this.sist7=true
  
   this.paretosit(this.chartpareto7,this.datapareto7,'pareto7',res[0]['info'][i]['descripcion']);
 
  }
   if(res[0]['info'][i]['id']==8)
   {this.sist8=true
 
   this.paretosit(this.chartpareto8,this.datapareto8,'pareto8',res[0]['info'][i]['descripcion']);

  }

   }

    }

  } catch (error) {

    console.log('error');
    
  }


  }

  camplanta(id){

    this.plantas.filter(x=> x.estado=false);
    this.plantas[id-1]['estado']=true;
    this.desplanta=this.plantas[id-1]['descripcion'];

    this.idplanta=this.plantas[id-1]['id'];

    if(!this.auxadm)
    this.modificarista();

  }

  camfecha(id){

   // console.log(this.listafecha);
    this.listafecha.filter(x=> x.estado=false);
    this.listafecha[id]['estado']=true;
   // console.log(this.listafecha);


  var auxfecha=moment().format("yyyy-MM-DD");
  var month = moment().format('MM');
  var day   = moment().format('DD');
  var year  = moment().format('YYYY');

  console.log(auxfecha);


   if(id==0){
 this.fedesde=moment( year+"-"+month+"-01").format("YY-MM-DD");
 this.fehasta=moment().format("YY-MM-DD");

   }
   if(id==1){
     //moment(fechadisparo).
    this.fedesde=moment().subtract(1,'months').format("yyyy-MM-DD");   //format("yyyy-MM-DD");
    this.fehasta=moment().format("yyyy-MM-DD");
  
   }
   if(id==2){

    this.fedesde=moment().subtract(6,'months').format("yyyy-MM-DD");   //format("yyyy-MM-DD");
    this.fehasta=moment().format("yyyy-MM-DD");
         
    
   }
   if(id==3){

    this.fedesde=moment().subtract(1,'year').format("yyyy-MM-DD");   //format("yyyy-MM-DD");
    this.fehasta=moment().format("yyyy-MM-DD");

   
         
    
   }
   if(id==4){

  this.fedesde=moment( year+"-01-01").format("yyyy-MM-DD");
  this.fehasta=moment().format("yyyy-MM-DD");

 
    
   }
   if(id==5){
    
   }

  //String(moment(fechadisparo).add(this.proestrategia[i]['dias'],'days').format("yyyy-MM-DD"));

  //modifico la vista de las ots....
 if(!this.auxadm)
  this.modificarista();

  }

  async modificarista(){

   if(!this.auxadm)
   this.apiservice.startloading();

    var mov={
    'idcod':'49',
    'bus':{'id':this.idplanta,'feini':this.fedesde,'fefin':this.fehasta}
    }

    var res= await this.apiservice.postbusapi2(mov);

    console.log(res);

   // this.datahorizontal[0]['value']=15;
   this.datahorizontal[0]['value']=0;
   this.datahorizontal[1]['value']=0;
   this.datahorizontal[2]['value']=0;
   this.datahorizontal[3]['value']=0;

   this.datahorizontal2[0]['value']=0;
   this.datahorizontal2[1]['value']=0;
   this.datahorizontal2[2]['value']=0;
   this.datahorizontal2[3]['value']=0;

   var suma=0;
   for(var i=0;i<res.length;i++){

    /////////////////////////////////////

      //0=>preventivo,1=>predictivo,2=>condicion,3=>correctivo	   

      if(res[i]['tipo']==0){ this.datahorizontal2[0]['value']=res[i]['suma']}
      if(res[i]['tipo']==1){ this.datahorizontal2[2]['value']=res[i]['suma']}
      if(res[i]['tipo']==2){ this.datahorizontal2[1]['value']=res[i]['suma']}
      if(res[i]['tipo']==3){ this.datahorizontal2[3]['value']=res[i]['suma']}

    /////////////////////////////////////

     var pos=res[i]['estadocond'];
     var xpos=0;
     suma+= res[i]['suma']*1;

     if(pos==0){ xpos=1; }     
    // if(pos==1){ xpos=0; }     
     if(pos==2){ xpos=2;}     
     if(pos==5){ xpos=3;}

     if(xpos>0)
     this.datahorizontal[xpos]['value']=res[i]['suma']*1

   }

   this.datahorizontal[0]['value']=suma;    

   /////////////////////////////////////////

    console.log(res);

  




/*
    datahorizontal2 = [
      {x: "OTS Preventivas", value: 0, fill: "#3dc2ff",id: "1"},  
      {x: "OTS Condicion", value: 0, fill: "#2dd36f",id: "2"},
      {x: "OTS Predictivas", value: 0, fill: "#ffc409",id: "0"},
      {x: "OTS Correctivas", value: 0, fill: "#eb445a",id: "5"},
    //... Puedes seguir añadiendo meses y colores aquí
  ];*/
    

   ////////////////////////////////////////

  // this.datapareto[0]['value']=this.datahorizontal[0]['value'];
    
   //actualiza las graficas...
   
  await this.grafbarhorizontal();
  await  this.grafbarhorizontal2();
  await  this.grafpie3d();
  await  this.infoplantas();
   
  
  setTimeout(() => {

    this.apiservice.closedloading();
    this.auxadm=false;
    
  }, 1500);
  

  }

 

  presentPopoverayuda(e: Event) {  
    
    //backdropDismiss
    this.popoverayuda.backdropDismiss=false;
    this.popoverayuda.event = e;
    this.isOpenayuda = true;
  }

  presentPopoverusuario(e: Event) {  
    
    //backdropDismiss
    this.popoverusuario.backdropDismiss=true;
    this.popoverusuario.event = e;
    this.isOpenusuario = true;
  }

  grafbarras(){

    var data = [
      ["Creadas", 10000],
      ["Ejecutadas", 12000],
    
    ];
    
    // create a chart
   var chart = anychart.column();

   chart.yScale().minimum(0);
    
    // create a column series and set the data
    var series = chart.column(data);

    chart.title('Gráfica de ejemplo');

    series.labels().enabled(true);
series.labels().format("{%value}");
series.labels().position("center-top");

chart.labels().enabled(true);
    chart.labels().format('{%value}');
    chart.container('chart-container');
    
    // set the container id
    chart.container("barras");
    
    // initiate drawing the chart
   // chart.draw();
  }

  grafpie3d(){

/*
    var data = [
      ["Creadas", this.datahorizontal[0]['value']],
      ["Pendientes",this.datahorizontal[1]['value']],
      ["Realizadas", this.datahorizontal[2]['value']],
      ["Canceladas", this.datahorizontal[3]['value']],
    
    ];


*/

this.datapie=[]

this.datapie.push( ["Creadas", this.datahorizontal[0]['value']],["Pendientes",this.datahorizontal[1]['value']], ["Realizadas",this.datahorizontal[2]['value']], ["Canceladas", this.datahorizontal[3]['value']])

  //var  chart = anychart.pie3d(this.datapie);
  this.chartpie.data([]);
  this.chartpie.data(this.datapie);

  this.chartpie.title('Porcentaje de OTS');

/* set the inner radius
(to turn the pie chart into a doughnut chart)*/
this.chartpie.innerRadius("30%");

 
    // set the container id
    this.chartpie.container("pie3d");
    
    // initiate drawing the chart
    this.chartpie.draw();


  }

  grafbarhorizontal(){

    this.chartbarra.yScale().minimum(0);
     this.chartbarra.yScale().ticks({interval: 1})
    
   //  series.name("Ots");         

    this.chartbarra.title('');     
    
    this.series.data([]);
    this.series.data(JSON.parse(JSON.stringify(this.datahorizontal)));
    this.chartbarra.container("barhorizontal");   

    var column = this.chartbarra.getSeriesAt(0);  
   
     column.labels().enabled(true).format('{%value}');
     column.tooltip().format('Value: {%value}');



    this.chartbarra.draw(true);
    

  }

  grafbarhorizontal2(){

    this.chartbarra2.yScale().minimum(0);
     this.chartbarra2.yScale().ticks({interval: 1})
    
   //  series.name("Ots");         

    this.chartbarra2.title('');     
    
    this.series2.data([]);
    this.series2.data(JSON.parse(JSON.stringify(this.datahorizontal2)));
    this.chartbarra2.container("barhorizontal2");   

    var column = this.chartbarra2.getSeriesAt(0);  
   
     column.labels().enabled(true).format('{%value}');
     column.tooltip().format('Value: {%value}');
    this.chartbarra2.draw(true);
    

  }

  pareto(){   

    
    this.chartpareto.data([]);
    this.chartpareto.data(this.datapareto);
   
    this.chartpareto.title('PARETO SIST ALMACENAMIENTO');
    // set measure y axis title
    this.chartpareto.yAxis(0).title('Defect frequency');
    // cumulative percentage y axis title
    this.chartpareto.yAxis(1).title('Cumulative Percentage');
    // set interval
    //chart.yAxis(1).scale().ticks().interval(10);

   // get pareto line series and set settings
   var line = this.chartpareto.getSeriesAt(1);
   line
     .tooltip()
     .format('Cumulative Frequency: {%CF}% \n Relative Frequency: {%RF}%');
 
   // create first horizontal line marker
   this.chartpareto
     .lineMarker(0)
     .axis(this.chartpareto.yAxis(1))
     .value(10)
     .stroke('#A5B3B3', 1, '10 2', 'round'); // sets stroke
 
   // create second horizontal line marker
   this.chartpareto
     .lineMarker(1)
     .axis(this.chartpareto.yAxis(1))
     .value(60)
     .stroke('#A5B3B3', 1, '10 2', 'round'); // sets stroke
 
   // turn on the crosshair and set settings
   this.chartpareto.crosshair().enabled(true).xLabel(false);
 
   // set container id for the chart
   this.chartpareto.container('pareto2');
   // initiate chart drawing
   this.chartpareto.draw();

     ////////////////////////////////////////////////

 

  }

  paretosit(chpa,datpa,cont,sistema){   

    
    chpa.data(datpa);
   
    chpa.title('PARETO '+sistema);
    // set measure y axis title
    chpa.yAxis(0).title('Defect frequency');
    // cumulative percentage y axis title
    chpa.yAxis(1).title('Cumulative Percentage');
    // set interval
    //chart.yAxis(1).scale().ticks().interval(10);

   // get pareto line series and set settings
   var line = chpa.getSeriesAt(1);
   line
     .tooltip()
     .format('Frecuencia Acomulada: {%CF}% \n Frecuencia Relativa: {%RF}%');
 
   // create first horizontal line marker
   chpa
     .lineMarker(0)
     .axis(chpa.yAxis(1))
     .value(10)
     .stroke('#A5B3B3', 1, '10 2', 'round'); // sets stroke
 
   // create second horizontal line marker
   chpa
     .lineMarker(1)
     .axis(chpa.yAxis(1))
     .value(60)
     .stroke('#A5B3B3', 1, '10 2', 'round'); // sets stroke
 
   // turn on the crosshair and set settings
   chpa.crosshair().enabled(true).xLabel(false);
 
   // set container id for the chart
   chpa.container(cont);
   // initiate chart drawing
   chpa.draw();

     ////////////////////////////////////////////////

  }

  estrategia(){

    var tiempo=[28,56,84,112,140,168,196,224,252,280,308,336]; //estatico

   
    var sitemas=[
      'SISTEMA ALMACENAMIENTO',
      'SISTEMA CONTRA INCENDIO',
      'SISTEMA ELECTRICO',
      'SISTEMA ENVASADO',
      'SISTEMA TRASIEGO',
      'SISTEMA DE LAVADO',
      'SISTEMA DE PESAJE',
      'SISTEMA REGISTRADORA'];
    
      var vectsitemas=[];   
       
var chart = anychart.ganttProject();

var vectmes=[];
var semanas=[];
var vectsistemas=[];
var mst=[];

///////////////////////////////////


///////////////////////////////////
var pos=1;

for(var s=0;s<sitemas.length;s++)

{

for(var i=1;i<=12;i++){


 for(var j=1;j<=4;j++){

   pos=pos+1;

   var sem= {
      id:String(pos),
      name: 'Semana '+j,
      actualStart: '2023-01-11',
      actualEnd: '2023-01-20',
      baselineStart: "2023-01-11",
      baselineEnd: "2023-01-20",
     
      children: [
       {
         id:String(pos+1),
         name: 'MST-BOMBA-7D ',
         actualStart: '2023-01-11',
         actualEnd: '2023-01-20',
         children: [],     
       },
       {
         id:String(pos+1),
         name: 'MST-COMPRESOR-7D ',
         actualStart: '2023-01-11',
         actualEnd: '2023-01-20',
         children: [],     
       },
       {
         id:String(pos+1),
         name: 'MST-TAMQUE-7D ',
         actualStart: '2023-01-11',
         actualEnd: '2023-01-20',
         children: [],     
       }


      ],     
      };

       pos=pos+3;
      semanas.push(sem);
 
   }

   pos=pos+1;


var mes= {
   id:String(pos),
   name: 'Mes '+i,
   actualStart: '2023-01-11',
   actualEnd: '2023-01-20',
   children:semanas,     
   };

   vectmes.push(mes);

   semanas=[];

}

pos=pos+1;

var sistuni=
{
 id:String(pos),
 name: sitemas[s],
 actualStart: '2023-01-11',
 actualEnd: '2023-01-20',
 children: vectmes,     
} 

vectsistemas.push(sistuni);

vectmes=[];

}



console.log(vectmes);

//////////////////////////////////////////////////

//cargo los sistemas






///////////////////////////////////////////////////


chart.data([
   {
     id:"1",
     name: 'Planta Pasto',
     progressValue: "20%",
     actualStart: '2023-01-01',
     actualEnd: '2023-01-10',
    // baselineStart: "2023-01-11",
    // baselineEnd: "2023-01-20",
     //baselineProgressValue:"40%",    
     baselineProgressValue: 0.5,
     children: vectsistemas,
     baselineProgress: {
      fill: '#eb445a'
     /* label: {
        enabled: true,
        fontColor: 'navy',
        format: 'Planned Progress: [{%baselineProgress}]'
      }*/
    }
     
   },

 ]);

 var baselines = chart.getTimeline().baselines();
// baselines.normal().fill("#dd2c00 0.3");
 baselines.normal().stroke(null);
 baselines.selected().fill("#ef6c00 0.3");
 baselines.selected().stroke(null);

 baselines.progress


 anychart.format.inputLocale('es-es');
// anychart.format.inputDateTimeFormat('yyyy.MM.dd'); //Like '2015.03.12'
 anychart.format.outputLocale('es-es');



chart.container('estrategia').draw();

  }

}
